import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/auth";

export default function Portfolio() {
  const [projects, setProjects] = useState([]);
  useEffect(() => { api.get("/portfolio").then((r) => setProjects(r.data)).catch(() => setProjects([])); }, []);

  return (
    <div data-testid="page-portfolio">
      <section className="cs-cream border-b border-black/10 py-20">
        <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
          <div className="cs-eyebrow text-neutral-500">Portfolio · Problèmes résolus</div>
          <h1 className="cs-h1 mt-4 text-5xl lg:text-7xl max-w-3xl">Le besoin, la solution, le résultat.</h1>
          <p className="mt-6 max-w-2xl text-neutral-700 cs-body text-[15px] sm:text-base">
            Le portfolio de Charbonier Studio ne s'écrit pas en grandes images muettes.
            Chaque projet publié raconte un besoin précis, la réponse apportée et le résultat concret pour l'imprimeur ou l'éditeur.
          </p>
        </div>
      </section>

      <section className="cs-cream py-16">
        <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
          {projects.length > 0 ? (
            <div className="grid md:grid-cols-2 gap-8">
              {projects.map((p) => (
                <article key={p.id} className="cs-card p-8" data-testid={`portfolio-${p.slug}`}>
                  <div className="cs-eyebrow text-neutral-500">{p.category}</div>
                  <h3 className="cs-h3 mt-3 text-3xl">{p.title}</h3>
                  <div className="mt-6 grid gap-4 text-[15px]">
                    <div><span className="cs-eyebrow text-neutral-500">Le besoin</span><p className="mt-1">{p.need}</p></div>
                    <div><span className="cs-eyebrow text-neutral-500">La solution</span><p className="mt-1">{p.solution}</p></div>
                    <div><span className="cs-eyebrow text-neutral-500">Le résultat</span><p className="mt-1">{p.result}</p></div>
                  </div>
                </article>
              ))}
            </div>
          ) : (
            <div className="border border-black/15 bg-white/60 p-10 max-w-3xl" data-testid="portfolio-coming-soon">
              <div className="cs-eyebrow text-neutral-500">Portfolio</div>
              <p className="mt-4 font-serif text-2xl leading-snug">Premières études de cas en préparation.</p>
              <p className="mt-4 text-[15px] text-neutral-700 leading-relaxed">
                Chaque projet publié présentera un besoin précis, la solution apportée et le résultat obtenu.
                Aucune image générique ni donnée inventée.
              </p>
              <div className="mt-6">
                <Link to="/demande-devis" className="text-sm cs-link-underline">Vous souhaitez confier un projet ? →</Link>
              </div>
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
